import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Sport from '../screens/sport/index';
import Login from '../screens/Login';
import ChangePassword from '../screens/ChangePassword';
import Home from '../screens/Home';
import Arrienda from '../screens/sport/arrienda/filter';
import Filter from '../screens/sport/arrienda/reservar/index';
import Clubes from '../screens/sport/arrienda/clubes/index';
import SignUp from '../screens/SignUp';
import Integrar from '../screens/sport/integrar/filter';
import Partidos from '../screens/sport/integrar/partidos/index';
import Inscription from '../screens/sport/integrar/unirse/index';
import TermsConditions from '../screens/TermsConditions';
import Defy from '../screens/sport/defy/filter';
import FilterDefy from '../screens/sport/defy/create/index';
import TeamsDefy from '../screens/sport/defy/teams/index';
import PositionsDefy from '../screens/sport/defy/positions/index';
import FilterReservar from '../screens/sport/defy/reservar/index';
import ClubesDefy from '../screens/sport/defy/clubes/index';
import ConfirmCode from '../screens/ConfirmCode';
import ChangePasswordCode from '../screens/ChangePasswordCode';
//import Pago from '../screens/sport/arrienda/pago/pago';
import Faq from '../screens/Faq';

const UnAuthenticated = (): JSX.Element => {
    return (
        <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/recuperar" exact component={ChangePassword} />
            <Route path="/recuperar/codigo" exact component={ChangePasswordCode} />
            <Route path="/login" exact component={Login} />
            <Route path="/registro" exact component={SignUp} />
            <Route path="/registro/codigo" exact component={ConfirmCode} />
            <Route path="/terminos-condiciones" exact component={TermsConditions} />
            <Route path="/preguntas-frecuentes" exact component={Faq} />

            {/*<Route path="/futbol/arrienda/pago/filter" exact component={Pago} />*/}
            {/*futbol */}
            <Route path="/futbol" exact component={Sport} />
            <Route path="/futbol/arrienda" exact component={Arrienda} />
            <Route path="/futbol/arrienda/reservar/filter" exact component={Filter} />
            <Route path="/futbol/arrienda/clubes/filter" exact component={Clubes} />
            <Route path="/futbol/integrar" exact component={Integrar} />
            <Route path="/futbol/integrar/partidos/filter" exact component={Partidos} />
            <Route path="/futbol/integrar/unirse/filter" exact component={Inscription} />
            <Route path="/futbol/desafiar" exact component={Defy} />
            <Route path="/futbol/desafiar/equipos/crear" exact component={FilterDefy} />
            <Route path="/futbol/desafiar/equipos/filter" exact component={TeamsDefy} />
            <Route path="/futbol/desafiar/equipos/posiciones/filter" exact component={PositionsDefy} />
            <Route path="/futbol/desafiar/reservar/filter" exact component={FilterReservar} />
            <Route path="/futbol/desafiar/clubes/filter" exact component={ClubesDefy} />

            {/*Padel */}
            <Route path="/padel" exact component={Sport} />
            <Route path="/padel/arrienda" exact component={Arrienda} />
            <Route path="/padel/arrienda/reservar/filter" exact component={Filter} />
            <Route path="/padel/arrienda/clubes/filter" exact component={Clubes} />
            <Route path="/padel/integrar" exact component={Integrar} />
            <Route path="/padel/integrar/partidos/filter" exact component={Partidos} />
            <Route path="/padel/integrar/unirse/filter" exact component={Inscription} />
            <Route path="/padel/desafiar" exact component={Defy} />
            <Route path="/padel/desafiar/equipos/crear" exact component={FilterDefy} />
            <Route path="/padel/desafiar/equipos/filter" exact component={TeamsDefy} />
            <Route path="/padel/desafiar/equipos/posiciones/filter" exact component={PositionsDefy} />
            <Route path="/padel/desafiar/reservar/filter" exact component={FilterReservar} />
            <Route path="/padel/desafiar/clubes/filter" exact component={ClubesDefy} />

            {/*Tenis */}
            <Route path="/tenis" exact component={Sport} />
            <Route path="/tenis/arrienda" exact component={Arrienda} />
            <Route path="/tenis/arrienda/reservar/filter" exact component={Filter} />
            <Route path="/tenis/arrienda/clubes/filter" exact component={Clubes} />
            <Route path="/tenis/integrar" exact component={Integrar} />
            <Route path="/tenis/integrar/partidos/filter" exact component={Partidos} />
            <Route path="/tenis/integrar/unirse/filter" exact component={Inscription} />
            <Route path="/tenis/desafiar" exact component={Defy} />
            <Route path="/tenis/desafiar/equipos/crear" exact component={FilterDefy} />
            <Route path="/tenis/desafiar/equipos/filter" exact component={TeamsDefy} />
            <Route path="/tenis/desafiar/equipos/posiciones/filter" exact component={PositionsDefy} />
            <Route path="/tenis/desafiar/reservar/filter" exact component={FilterReservar} />
            <Route path="/tenis/desafiar/clubes/filter" exact component={ClubesDefy} />
            {/*Basquetbol */}
            <Route path="/basquetbol" exact component={Sport} />
            <Route path="/basquetbol/arrienda" exact component={Arrienda} />
            <Route path="/basquetbol/arrienda/reservar/filter" exact component={Filter} />
            <Route path="/basquetbol/arrienda/clubes/filter" exact component={Clubes} />
            <Route path="/basquetbol/integrar" exact component={Integrar} />
            <Route path="/basquetbol/integrar/partidos/filter" exact component={Partidos} />
            <Route path="/basquetbol/integrar/unirse/filter" exact component={Inscription} />
            <Route path="/basquetbol/desafiar" exact component={Defy} />
            <Route path="/basquetbol/desafiar/equipos/crear" exact component={FilterDefy} />
            <Route path="/basquetbol/desafiar/equipos/filter" exact component={TeamsDefy} />
            <Route path="/basquetbol/desafiar/equipos/posiciones/filter" exact component={PositionsDefy} />
            <Route path="/basquetbol/desafiar/reservar/filter" exact component={FilterReservar} />
            <Route path="/basquetbol/desafiar/clubes/filter" exact component={ClubesDefy} />
            <Route path="/" component={Login} />
        </Switch>
    );
};

export default UnAuthenticated;
